import { Paper, Stack } from "@mui/material";
import { ReactNode } from "react";

import { theme } from "~/config/theme";

type GaiaExpandableMapMarkerHeaderProps = {
    children?: ReactNode;
};

export function GaiaExpandableMapMarkerHeader({ children }: GaiaExpandableMapMarkerHeaderProps) {
    return (
        <Stack
            component={Paper}
            columnGap={2}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                gridArea: "heading",
                borderTopLeftRadius: "50px",
                borderBottomLeftRadius: "50px",

                padding: 0.5,
                paddingInlineEnd: 1,

                cursor: "pointer",
                overflow: "hidden",
                textWrap: "nowrap",

                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark,
            }}
        >
            {children}
        </Stack>
    );
}
